module.exports = __webpack_public_path__ + "media/images/IISAD_logo-f1b69769.svg";